// Encart d'inscription à la newsletter (snippets/alnatea-newsletter.liquid).
// Apparition : après 20 s ou à mi-page ; jamais si déjà inscrit, ni pendant 30 jours après fermeture,
// ni sur une fiche produit qui est la première page de la visite.
// Après une inscription (?customer_posted=true), l'encart s'ouvre directement sur le code.
(function () {
  var boite = document.getElementById('AlnateaNewsletter');
  if (!boite) return;

  var CLE_FERME = 'alnatea-nl-ferme';
  var CLE_INSCRIT = 'alnatea-nl-inscrit';
  var DELAI_MS = 20000;
  var MASQUE_JOURS = 30;

  // Le stockage local peut être indisponible (navigation privée) : on ne bloque jamais l'affichage.
  function lire(cle) { try { return window.localStorage.getItem(cle); } catch (e) { return null; } }
  function ecrire(cle, val) { try { window.localStorage.setItem(cle, val); } catch (e) {} }

  function ouvrir() {
    boite.hidden = false;
    requestAnimationFrame(function () { boite.classList.add('al-nl--visible'); });
  }
  function fermer() {
    boite.classList.remove('al-nl--visible');
    setTimeout(function () { boite.hidden = true; }, 250);
    ecrire(CLE_FERME, String(Date.now()));
  }

  boite.querySelector('[data-al-nl-fermer]').addEventListener('click', fermer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !boite.hidden) fermer();
  });

  var copier = boite.querySelector('[data-al-nl-copier]');
  copier.addEventListener('click', function () {
    var code = boite.querySelector('[data-al-nl-code]').textContent.trim();
    var fini = function () { copier.textContent = 'Copié'; };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(fini, function () {});
  });

  // Retour d'inscription réussie (cet encart ou la section newsletter de l'accueil).
  if (/[?&]customer_posted=true/.test(window.location.search)) {
    ecrire(CLE_INSCRIT, '1');
    boite.querySelector('[data-al-nl-inscription]').hidden = true;
    boite.querySelector('[data-al-nl-merci]').hidden = false;
    ouvrir();
    return;
  }

  if (boite.dataset.abonne === 'true' || lire(CLE_INSCRIT)) return;

  // 2026-10-20 : jamais sur la première page de la visite quand c'est une fiche produit
  // (arrivées par Google Shopping : on laisse le visiteur découvrir le produit).
  var pages = 1;
  try {
    pages = Number(window.sessionStorage.getItem('alnatea-nl-pages') || 0) + 1;
    window.sessionStorage.setItem('alnatea-nl-pages', String(pages));
  } catch (e) {}
  if (pages === 1 && /\/products\//.test(window.location.pathname)) return;
  var ferme = Number(lire(CLE_FERME) || 0);
  if (ferme && Date.now() - ferme < MASQUE_JOURS * 864e5) return;

  // Erreur de saisie renvoyée par Shopify : l'encart reste ouvert pour corriger.
  if (boite.querySelector('.errors')) { ouvrir(); return; }

  var lance = false;
  function declencher() {
    if (lance) return;
    lance = true;
    window.removeEventListener('scroll', auDefilement);
    ouvrir();
  }
  function auDefilement() {
    var h = document.documentElement;
    if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.5) declencher();
  }
  setTimeout(declencher, DELAI_MS);
  window.addEventListener('scroll', auDefilement, { passive: true });
})();
